/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var config       = require('../../config'),
    $spinnerNode = document.getElementById('spinner'),
    timeout;

/**
 * Preloader animation module
 */
module.exports = {

    /**
     * Show preloader animation
     */
    show: function () {
        // disable animation
        if ( core && core.device && config.disableSpinnerAnimation.indexOf(core.device.model) > -1 ) {
            return;
        }
        $spinnerNode.classList.add('on');
    },

    /**
     * Shortcut to start spinner after time, need to prevent manually clear timeout
     *
     * @param {number} milliseconds - milliseconds to setTimeout to show
     */
    showAfter: function ( milliseconds ) {
        var self = this;

        clearTimeout(timeout);
        timeout = setTimeout(self.show, milliseconds);
    },

    /**
     * Hide preloader animation
     */
    hide: function () {
        $spinnerNode.classList.remove('on');
        clearTimeout(timeout);
    }
};
